module.exports = __webpack_public_path__ + "static/media/banner-img2.cbb4eddb.jpg";